module.exports = __webpack_public_path__ + "img/kiosk.eedbd03d.png";